import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import { LoadingButton } from "@mui/lab";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import RootHeader from "../../RootHeader/RootHeader";
import { signInAdmin } from "../../../firebase/functions";
import encryptor from "../../../utils/encryptor";
function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}>
      {"Copyright "} &copy;{" "}
      <Link color="inherit" href="https://mui.com/">
        Paul Omachi Memorial School
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function SignIn({ setAuth }) {
  const [loading, setLoading] = useState();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const data = new FormData(event.currentTarget);
    if (
      await signInAdmin({
        username: data.get("username"),
        psw: data.get("password"),
      })
    ) {
      window.localStorage.setItem("_auth", encryptor.encrypt("true"));
      setAuth(true);
      navigate("/admin");
    }

    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <RootHeader />
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Admin
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="User Name"
            name="username"
            autoComplete="username"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          <LoadingButton
            type="submit"
            fullWidth
            color="primary"
            variant="contained"
            loadingPosition="start"
            loading={loading}
            sx={{ mt: 2, mb: 2 }}>
            Sign In
          </LoadingButton>
          <Grid container spacing={1}>
            <Grid item xs>
              <Link href="#" variant="body2">
                Forgot password
              </Link>
            </Grid>
            <Grid item xs>
              <Link href="#" variant="body2">
                Having issues with account?
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Copyright sx={{ mt: 4, mb: 2 }} />
    </Container>
  );
}
